export const storyFacts = [
  { id: 'date', icon: 'ri-calendar-line' },
  { id: 'venue', icon: 'ri-map-pin-2-line' },
  { id: 'guests', icon: 'ri-group-line' },
  { id: 'coverage', icon: 'ri-camera-lens-line' },
  { id: 'style', icon: 'ri-heart-3-line' },
]

export const storyTimeline = [
  { id: 'ws1', step: '01', icon: 'ri-sun-line' },
  { id: 'ws2', step: '02', icon: 'ri-fire-line' },
  { id: 'ws3', step: '03', icon: 'ri-heart-3-line' },
  { id: 'ws4', step: '04', icon: 'ri-group-line' },
  { id: 'ws5', step: '05', icon: 'ri-camera-lens-line' },
]

export const storyGalleryCategories = [{ id: 'story' }]

export const storyGalleryItems = [
  {
    id: 'sg1',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20exchanging%20jasmine%20garlands%20during%20a%20temple%20wedding%20muhurtham%2C%20warm%20golden%20morning%20light%2C%20emotional%20candid%20moment%2C%20cinematic%20editorial%20photography%2C%20rich%20amber%20tones%2C%20soft%20bokeh%20background&width=900&height=1100&seq=shabi-story-01&orientation=portrait&nocache=true',
  },
  {
    id: 'sg2',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20in%20red%20kanjivaram%20silk%20saree%20with%20temple%20gold%20jewellery%20praying%20before%20the%20wedding%20ceremony%2C%20warm%20lamp%20light%2C%20elegant%20luxury%20photography%2C%20rich%20amber%20tones%2C%20soft%20dark%20background&width=900&height=1100&seq=shabi-story-02&orientation=portrait&nocache=true',
  },
  {
    id: 'sg3',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=close%20up%20of%20South%20Indian%20Tamil%20bridal%20hands%20with%20mehendi%20and%20gold%20bangles%20holding%20a%20garland%2C%20warm%20candle%20lighting%2C%20rich%20detail%2C%20cinematic%20warm%20tones%2C%20shallow%20depth%20of%20field&width=900&height=1100&seq=shabi-story-03&orientation=portrait&nocache=true',
  },
  {
    id: 'sg4',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20wedding%20mandapam%20rituals%20with%20sacred%20fire%20and%20priest%20blessing%20the%20couple%2C%20marigold%20decor%2C%20warm%20golden%20lighting%2C%20candid%20documentary%20photography%2C%20rich%20warm%20tones&width=900&height=1100&seq=shabi-story-04&orientation=portrait&nocache=true',
  },
  {
    id: 'sg5',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=joyful%20South%20Indian%20Tamil%20newlywed%20couple%20laughing%20with%20family%20during%20wedding%20blessings%2C%20rice%20showering%20ritual%2C%20warm%20golden%20light%2C%20candid%20emotional%20documentary%20photography%2C%20rich%20amber%20tones&width=900&height=1100&seq=shabi-story-05&orientation=portrait&nocache=true',
  },
  {
    id: 'sg6',
    category: 'story',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20sitting%20together%20at%20a%20decorated%20wedding%20reception%20stage%2C%20elegant%20floral%20backdrop%2C%20warm%20evening%20lighting%2C%20cinematic%20editorial%20wedding%20photography%2C%20rich%20amber%20and%20gold%20tones&width=900&height=1100&seq=shabi-story-06&orientation=portrait&nocache=true',
  },
]